export default __webpack_public_path__ + "static/media/backArrow.bfae8a14.svg";